var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.root},[_c('VTextarea',{attrs:{"label":_vm.label,"value":_vm.text,"rows":"1","auto-grow":"","dense":"","outlined":"","readonly":"","hideDetails":"auto"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }